import { TextField as MuiTextField, InputAdornment, IconButton } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PropTypes from "prop-types";

const PasswordField = ({ name, label, required, disabled, ...rest }) => {
  const { control } = useFormContext();

  const [showPassword, setShowPassword] = useState(false);
  
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <MuiTextField
            {...field}
            label={label}
            variant="outlined"
            fullWidth
            type={showPassword ? "text" : "password"}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            required={required}
            disabled={disabled}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff color="primary" /> : <Visibility color="primary" />}
                  </IconButton>
                </InputAdornment>
              ),
              ...rest.InputProps
            }}
            {...rest}
          />
        )}
      />
    </>
  );
};

PasswordField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,

  disabled: PropTypes.bool,
};

export default PasswordField;
